/**
 * 파트너 연락 방식 (SIF-3) — TS_PARTNER.COMM_YN
 *   Y = 알림톡 발송-회신 (기본) · N = 결과만 직접등록
 * 시공파트너 · 자재파트너 등록 화면(페이지 · 빠른 등록 팝업)과 인디플래너 · 인디공사현황의 '결과만 직접등록' 배지가 같은 이름을 쓴다.
 */

/** 연락 방식 N 의 이름 — 등록 화면 선택지 · 배지 공통 */
export const COMM_METHOD_DIRECT_LABEL = '결과만 직접등록';

export const COMM_METHOD_OPTIONS: { value: 'Y' | 'N'; label: string }[] = [
  { value: 'Y', label: '알림톡 발송-회신' },
  { value: 'N', label: COMM_METHOD_DIRECT_LABEL },
];

/** 결과만 직접등록 파트너인지 — 값이 없으면(미제공) 알림톡 발송-회신으로 본다 */
export function isDirectRecord(commYn: string | null | undefined): boolean {
  return commYn === 'N';
}

/** 안내 문구 — 시공파트너 등록(F-1) */
export const COMM_METHOD_HELP_CONSTRUCTION =
  '[결과만 직접등록]이면 일정확인 · 작업요청 알림톡을 보내지 않고 영업사원이 결과만 등록해요';

/** 안내 문구 — 자재파트너 등록(G-1) */
export const COMM_METHOD_HELP_MATERIAL =
  '[결과만 직접등록]이면 알림톡을 보내지 않고 영업사원이 결과만 등록해요';
